import { connect } from 'react-redux';
import { compose, branch, renderComponent } from 'recompose';

import CurrentAppointmentInfoSidebar from 'modules/appointmentInfo/components/AppointmentInfoSidebar';
import AppointmentsSidebar from './components/AppointmentsSidebar';

export default compose(
  connect((state) => ({
    isAppointmentInfoShown: state.queues.common.appointmentInfo.isAppointmentInfoShown,
  })),
  branch(({ isAppointmentInfoShown }) => isAppointmentInfoShown, renderComponent(CurrentAppointmentInfoSidebar)),
)(AppointmentsSidebar);
